import { mailingCommunicationStore } from '@/services/MailingCommunications/store'

export const methods = {
  async reload() {
    this.loading = true

    this.communicationID = this.$route.params.id || 0

    console.debug('redirected from parent communicationID=' + JSON.stringify(this.$route.params.id))

    if (this.communicationID !== undefined && this.communicationID > 0) {
      await this.loadCurrentCommunication()
    }

    this.loading = false
  },

  async loadCurrentCommunication() {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    try {
      this.validationMessages = ''
      console.debug('loadCurrentCommunication=' + JSON.stringify(this.communication))
      if (this.communicationID !== undefined && this.communicationID) {
        console.debug('in loadCurrentCommunication...')
        await mailingCommunicationStore
          .dispatch('getCommunicationById', {
            communicationID: this.communicationID
          })
          .then(async ({ result }) => {
            if (result) {
              this.communication = result

              console.debug('this.communication...' + JSON.stringify(this.communication))

              //Set readonly and communication state variables
              if (this.communication !== undefined && this.communication) {
                this.$store.dispatch('communication/saveSessionCommunicationID', {
                  mailingCommunicationID: this.communicationID
                })

                this.$store.dispatch('communication/saveMailingTypeID', {
                  mailingTypeID: this.communication.mailingTypeID
                })

                this.$store.dispatch('communication/saveHasReadonly', {
                  hasReadonly: this.communication.sentDate ? true : false
                })

                if (this.communication.timezoneName) {
                  this.$store.dispatch('communication/saveTimezone', {
                    hasReadonly: this.communication.timezoneName
                  })
                } else {
                  this.$store.dispatch('communication/saveTimezone', {
                    hasReadonly: 'Not Set Up'
                  })
                }

                this.$store.dispatch('communication/saveCompositionMethod', {
                  compositionMethod: this.communication.compositionMethod
                })

                this.$store.dispatch('communication/saveSupportMailDelivery', {
                  supportMailDelivery: this.communication.supportMailDelivery
                })

                this.$store.dispatch('communication/saveSupportEmailDelivery', {
                  supportEmailDelivery: this.communication.supportEmailDelivery
                })

                this.$store.dispatch('communication/saveSupportSMSDelivery', {
                  supportSMSDelivery: this.communication.supportSMSDelivery
                })

                this.$store.dispatch('communication/saveIsLegalCommunication', {
                  isLegalCommunication: this.communication.isLegalCommunication
                })

                this.$store.dispatch('communication/saveMailingTypeID', {
                  mailingTypeID: this.communication.mailingTypeID
                })

                this.$store.dispatch('communication/composedMailMessage', {
                  mailMessage: this.communication.htmlContent
                })

                this.$store.dispatch('communication/composedEmailMessage', {
                  emailMessage: this.communication.htmlEmailContent
                })

                this.$store.dispatch('communication/composedEmailSubject', {
                  emailMessageSubject: this.communication.emailSubject
                })

                this.$store.dispatch('communication/savePdfFileName', {
                  pdfFileName: this.communication.pdfFileName
                })

                this.$store.dispatch('communication/saveSessionCommunicationID', {
                  mailingCommunicationID: this.communication.communicationID
                })

                this.$store.dispatch('communication/saveDescription', {
                  communicationDescription: this.communication.description
                })

                if (
                  this.communication.communicationDeliveryOwners !== undefined &&
                  this.communication.communicationDeliveryOwners
                ) {
                  let ownerIDs = []
                  Array.from(this.communication.communicationDeliveryOwners).forEach(owner => {
                    if (owner.ownerID) {
                      console.debug('in communication ownerIds...' + owner.ownerID)
                      ownerIDs.push(owner.ownerID)
                    }
                  })

                  this.$store.dispatch('communication/saveDeliveryOwnerIDs', {
                    selectedDeliveryOwnerIDs: ownerIDs
                  })
                }

                this.$store.dispatch('communication/saveDeliveryOwners', {
                  selectedDeliveryOwners: this.communication.deliveryAudience
                })

                this.$store.dispatch('communication/saveDeliveryDate', {
                  deliveryDate: this.communication.deliveryDate
                })

                this.$store.dispatch('communication/saveIsFullDuplex', {
                  isFullDuplex: this.communication.mailFullDuplex
                })

                this.$store.dispatch('communication/saveIsColor', {
                  isColor: this.communication.mailColor
                })

                this.$store.dispatch('communication/composedSmsMessage', {
                  smsMessage: this.communication.htmlSmsContent
                })

                this.$store.dispatch('communication/saveSmsSubject', {
                  smsSubject: this.communication.smsSubject
                })

                this.$store.dispatch('communication/saveDeliveryDate', {
                  deliveryDate: this.communication.deliveryDate
                })

                let mType = ''
                if (this.communication.supportMailDelivery === true) {
                  mType = 'Mail'
                } else if (this.communication.supportEmailDelivery === true) {
                  mType = 'Email'
                } else if (this.communication.supportSMSDelivery === true) {
                  mType = 'SMS'
                }

                console.debug('mType1=' + mType)

                if (mType === '') {
                  if (
                    this.communication.compositionMethod === 'pdf-document' ||
                    (this.communication.compositionMethod === 'html' &&
                      this.communication.htmlContent &&
                      !this.communication.htmlEmailContent &&
                      !this.communication.htmlSmsContent)
                  ) {
                    mType = 'Mail'
                    this.$store.dispatch('communication/saveSupportMailDelivery', {
                      supportMailDelivery: this.communication.supportMailDelivery
                    })
                  } else if (this.communication.htmlEmailContent.length > 0) {
                    mType = 'Email'
                    this.$store.dispatch('communication/saveSupportEmailDelivery', {
                      supportEmailDelivery: this.communication.supportEmailDelivery
                    })
                  } else if (this.communication.htmlSmsContent.length > 0) {
                    mType = 'Sms'
                    this.$store.dispatch('communication/saveSupportSMSDelivery', {
                      supportSMSDelivery: this.communication.supportSMSDelivery
                    })
                  }

                  console.debug('mType2=' + mType)
                }

                this.$store.dispatch('communication/saveMailingType', {
                  mailingType: mType
                })

                console.debug('mType3=' + mType)
              }
            }
          })
      } else {
        console.debug('else init states in index')
        //init all session state variables
        this.$store.dispatch('communication/initStatesExceptMailingType')
      }
    } catch (e) {
      console.error('there was an issue loading get communication by id' + e.error)
    }

    loadingComponent.close()
  },

  returnToParent() {
    this.$router.push({
      name: 'communications'
    })
  }
}
